<template>
  <v-container fluid class="cargamasiva">
    <v-row>
      <!-- Lado izquierdo: archivos cargados -->
      <v-col cols="8">
        <v-card class="pa-4" outlined>
          <v-card-title>
            Archivos cargados ({{ files.length }}) - {{ totalSizeMB }} MB
            <v-spacer></v-spacer>
            <v-btn color="success" @click="procesarArchivos" :disabled="files.length === 0">
              Procesar Archivos
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-row>
            <v-col
              v-for="(archivo, index) in files"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card outlined>
                <v-card-text>
                  <v-icon color="primary" large>mdi-file-pdf</v-icon>
                  <div class="truncate-text mt-2">{{ archivo.name }}</div>
                  <div class="mt-2 text-caption grey--text">
                    {{ uploadStatus[index] || '' }}
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn small color="success" @click="previewFile(archivo)">
                    <v-icon small>mdi-eye</v-icon> Ver
                  </v-btn>
                  <v-btn
                    small
                    color="red"
                    @click="removeFile(index)"
                    :disabled="archivosCargados"
                  >
                    <v-icon small>mdi-delete</v-icon> Eliminar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- Lado derecho: Drag & drop y controles -->
      <v-col cols="4">
        <v-card class="pa-4" outlined>
          <h5 class="mb-4">Carga de archivos</h5>

          <div
            class="drag-drop-area"
            @dragover.prevent
            @drop.prevent="handleDrop"
          >
            <v-icon x-large color="grey">mdi-file-upload</v-icon>
            <p>Arrastra tus archivos PDF aquí o haz clic abajo</p>
            <v-btn color="primary" @click="selectFiles">
              Seleccionar Archivos
            </v-btn>
            <input type="file" multiple ref="fileInput" hidden @change="onFileChange" accept="application/pdf" />
          </div>

          <v-progress-linear :value="uploadProgress" v-if="uploading" color="blue" height="6"></v-progress-linear>

          <v-divider class="my-4"></v-divider>
          <!-- 
            <div class="text-caption text-right" v-if="totalSizeMB>100">La carga superior a 100 MB, se realizará por medio asincrono.</div>
            <div class="text-caption text-right" v-if="totalSizeMB<=100">La carga inferior a 100 MB, se realizará directa.</div> 
          -->
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showPreview" max-width="900px">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Vista previa de archivo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showPreview = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <iframe :src="previewSrc" width="100%" height="600px"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
    <section v-if="loading">
      <div class="loading">
        <div class="loadingio-spinner-spinner-2by998twmg8">
          <div class="ldio-yzaezf3dcmj">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <h4>{{ loadingText }}</h4>
      </div>
    </section>
  </v-container>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
// import { promisePool } from "../../../../utils/promisePool";
export default {
  data() {
    return {
      tipoArchivo: '',
      files: [],
      uploadStatus: [],
      showPreview: false,
      previewSrc: '',
      uploadProgress: 0,
      uploading: false,
      idCarga: 0,
      loading: false,
      loadingText: 'Cargando archivos',
      archivosCargados: false,

      concurrency: 50,
      maxRetries: 2,
      chunkSize: 500,

      tabId: null
    };
  },
  computed: {
    totalSizeMB() {
      if (!this.files || !this.files.length) return "0.00";
      const totalBytes = this.files.reduce((total, file) => total + file.size, 0);
      const totalMB = (totalBytes / (1024 * 1024)).toFixed(2);
      return totalMB;
    }
  },
  mounted() {
    this.tabId = Date.now().toString() + '_' + Math.random().toString(36).substr(2)
    localStorage.setItem('cargasView_' + this.tabId, 'true')
    window.addEventListener('beforeunload', this.removeTabFlag)
  },
  beforeDestroy() {
    this.removeTabFlag()
    window.removeEventListener('beforeunload', this.removeTabFlag)
  },
  methods: {
    removeTabFlag() {
      localStorage.removeItem('cargasView_' + this.tabId)
    },
    selectFiles() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const newFiles = Array.from(e.target.files);
      this.files.push(...newFiles);
    },
    handleDrop(e) {
      const droppedFiles = Array.from(e.dataTransfer.files);
      this.files.push(...droppedFiles);
      
      this.uploadStatus = this.files.map(() => "Pendiente");
    },
    previewFile(archivo) {
      this.previewSrc = URL.createObjectURL(archivo);
      this.showPreview = true;
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    handleFiles(event) {
      this.files = Array.from(event.target.files);
      this.uploadStatus = this.files.map(() => "Pendiente");
    },

    async prepararFormDataConBase64(file) {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]); 
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
      });    

      return base64;
    },

    async uploadFileUnit() {
      this.loading = true;

      for (let index = 0; index < this.files.length; index++) {
        const file = this.files[index];
        const base64 = await this.prepararFormDataConBase64(file);

        const payload = {
          file: base64,
          carga: this.idCarga,
          tipo: this.tipoArchivo,
          name: file.name
        };

        try {
          this.$set(this.uploadStatus, index, 'Cargando…');
          const response = await this.$http.post(
            "msa-tasks/api/expediente/upload-unit",
            payload,
            { headers: { 'Accept': 'application/json' }}
          );

          if (response.status === 200) {
            this.$set(this.uploadStatus, index, 'Cargado ✅');
          } else {
            this.$set(this.uploadStatus, index, 'Error ❌');
            console.error('Error al subir archivo, status:', response.status);
          }

        } catch (err) {
          this.$set(this.uploadStatus, index, 'Error ❌');
          console.error('Error en uploadFileUnit:', err);
        }
      }

      this.loading = false;
      this.archivosCargados = false;
      this.files= [];
      Swal.fire({
        title: 'Carga completada',
        text: 'Todos los archivos han sido procesados exitosamente.',
        icon: 'success'
      });

      console.log('Todos los archivos han sido procesados unitariamente');
    },

    getPresignedUrls (files) {
      const requests = files.map(file => ({
        fileName: file.name,
        contentType: file.type || "application/pdf",
        carga: this.idCarga,       
        tipo: this.tipoArchivo 
      }));

      return this.$http
        .post("msa-tasks/api/expediente/presigned-urls", requests)
        .then(response => {
          console.log("URLs firmadas recibidas:", response.data);
          return response.data;
        });
    },
    
    uploadFileAsync() {
      this.getPresignedUrls(this.files)
        .then(urlsArray => {
          const uploadPromises = this.files.map((file, index) => {
            const presignedUrl = urlsArray[index].url;
            console.log(`Subiendo archivo ${file.name} a ${presignedUrl}`);
            
            const axiosNoAuth = axios.create();
            const contentType = file.type || "application/pdf";

            return axiosNoAuth.put(presignedUrl, file, {
              headers: { "Content-Type": contentType }
            })
            .then(response => {
              if (response.status === 200) {
                this.$set(this.uploadStatus, index, "Cargado ✅");
              } else {
                this.$set(this.uploadStatus, index, "Error ❌");
                console.error("Error al subir archivo, status:", response.status);
              }
            })
            .catch(error => {
              console.error("Error al subir archivo:", error);
              this.$set(this.uploadStatus, index, "Error ❌");
            });
          });

          return Promise.all(uploadPromises);
        })
        .then(() => {
          this.loading=false;
          this.archivosCargados = true;
          this.files= [];
          Swal.fire({
            title: 'Carga completada',
            text: 'Todos los archivos han sido procesados exitosamente.',
            icon: 'success'
          });
          console.log("Todos los archivos han sido procesados");
        })
        .catch(error => {
          console.error("Error al obtener URLs firmadas o en el proceso de subida:", error);
        });
    },
    

    async promisePool(tasks = [], concurrency = this.concurrency) {
      let i = 0
      const results = []
      const runner = async () => {
        while (i < tasks.length) {
          const idx = i++
          try {
            results[idx] = await tasks[idx]()
          } catch (e) {
            results[idx] = Promise.reject(e)
          }
        }
      }
      await Promise.all(Array(concurrency).fill().map(runner))
      return results
    },

    async uploadWithRetry(url, file) {
      const delay = ms => new Promise(r => setTimeout(r, ms))
      for (let attempt = 1; attempt <= this.maxRetries + 1; attempt++) {
        try {
          await axios.put(url, file, {
            headers: { 'Content-Type': file.type || 'application/pdf' }
          })
          return
        } catch (err) {
          if (attempt > this.maxRetries) throw err
          await delay(1000 * attempt)
        }
      }
    },

    getPresignedUrlsChunk(filesChunk) {
      const tipo = this.tipoArchivo === 'FÓRMULA' ? 'ATTACHMENT' : 'HISTORY'
      const requests = filesChunk.map(f => ({
        fileName: f.name,
        contentType: f.type || 'application/pdf',
        carga: this.idCarga,
        tipoArchivo: tipo
      }))
      return this.$http
        .post('msa-tasks/api/expediente/presigned-urls', requests)
        .then(r => r.data)  
    },






    async procesarArchivos() {

      const { isConfirmed } = await Swal.fire({
        icon: 'question',
        html: `
          <strong>Cantidad:</strong> ${this.files.length}<br>
          <strong>Peso total:</strong> ${this.totalSizeMB} MB
        `,
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar'
      });

      if (!isConfirmed) return;

      this.loading = true;

      const formData = new FormData();
      formData.append('tipoArchivo', "HISTORY");

      this.files.forEach((file) => {
        formData.append('files', file);
      });

      try {
        const response = await this.$http.post(
          'msa-tasks/api/expediente/cargar-archivos-expediente',
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        if (response.status === 200) {
          Swal.fire({ icon: 'success', title: 'Carga completada' });
        } else {
          Swal.fire({ icon: 'error', title: 'Error en la carga' });
        }
      } catch (error) {
        console.error(error);
        Swal.fire({ icon: 'error', title: 'Error en la carga' });
      } finally {
        this.loading = false;
        this.files = [];
      }
    }
  },
};
</script>

<style scoped>

.cargamasiva {
  overflow-x: hidden;
  height: calc(100vh - 70px);
  overflow-y: auto;
}

.drag-drop-area {
  border: 2px dashed #ccc;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  border-radius: 10px;
}
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  z-index: 2;
}

.loading h4 {
  width: 100%;
  text-align: center;
  color: white;
  font-size: 19px;
  margin-top: -20px;
  font-weight: 200;
}

@keyframes ldio-yzaezf3dcmj {
  0% {
    opacity: 1
  }

  100% {
    opacity: 0
  }
}

.ldio-yzaezf3dcmj div {
  left: 96px;
  top: 45px;
  position: absolute;
  animation: ldio-yzaezf3dcmj linear 1s infinite;
  background: #0d47a1;
  width: 8px;
  height: 18px;
  border-radius: 3.42px / 3.42px;
  transform-origin: 4px 55px;
}

.ldio-yzaezf3dcmj div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -0.9375s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(2) {
  transform: rotate(22.5deg);
  animation-delay: -0.875s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(3) {
  transform: rotate(45deg);
  animation-delay: -0.8125s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(4) {
  transform: rotate(67.5deg);
  animation-delay: -0.75s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(5) {
  transform: rotate(90deg);
  animation-delay: -0.6875s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(6) {
  transform: rotate(112.5deg);
  animation-delay: -0.625s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(7) {
  transform: rotate(135deg);
  animation-delay: -0.5625s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(8) {
  transform: rotate(157.5deg);
  animation-delay: -0.5s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(9) {
  transform: rotate(180deg);
  animation-delay: -0.4375s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(10) {
  transform: rotate(202.5deg);
  animation-delay: -0.375s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(11) {
  transform: rotate(225deg);
  animation-delay: -0.3125s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(12) {
  transform: rotate(247.5deg);
  animation-delay: -0.25s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(13) {
  transform: rotate(270deg);
  animation-delay: -0.1875s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(14) {
  transform: rotate(292.5deg);
  animation-delay: -0.125s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(15) {
  transform: rotate(315deg);
  animation-delay: -0.0625s;
  background: #0d47a1;
}

.ldio-yzaezf3dcmj div:nth-child(16) {
  transform: rotate(337.5deg);
  animation-delay: 0s;
  background: #0d47a1;
}

.loadingio-spinner-spinner-2by998twmg8 {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
}

.ldio-yzaezf3dcmj {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
  /* see note above */
}

.ldio-yzaezf3dcmj div {
  box-sizing: content-box;
}
</style>
